export const validation = {
  features: {
    min: 1,
    max: 6
  },
  headingMaxChar: 120,
  subHeadingMaxChar: 120,
  paragraphMaxChar: 1500,
  badgeMaxChar: 30,
  countMaxChar: 10,
  blockParagraphMaxChar: 500,
  ctaHeadingMaxChar: 120
}
